/* extra10: confirm server state, keep product selection and drawer open. */
(function () {
  'use strict';
  var busy = false, state = 'idle', timer;
  var root = (window.Shopify && Shopify.routes.root) || '/';
  var saved = false;
  try { saved = sessionStorage.getItem('helix-extra10-saved') === '1'; } catch (_) {}
  function applied(cart) {
    var discounts = (cart.cart_level_discount_applications || []).slice();
    (cart.items || []).forEach(function (item) {
      (item.line_level_discount_allocations || []).forEach(function (a) { discounts.push(a.discount_application); });
      (item.discounts || []).forEach(function (a) { discounts.push(a); });
    });
    return discounts.some(function (d) { return d && String(d.title || d.code).toLowerCase() === 'extra10'; }) ||
      (cart.discount_codes || []).some(function (d) { return String(d.code).toLowerCase() === 'extra10' && d.applicable === true; });
  }
  function paint() {
    document.querySelectorAll('.helix-coupon').forEach(function (card) {
      var ar = card.getAttribute('dir') === 'rtl', button = card.querySelector('[data-helix-coupon]');
      var status = card.querySelector('[data-helix-coupon-status]');
      if (!button) return;
      var labels = ar ? {idle:'تطبيق الكوبون',busy:'جاري التطبيق…',applied:'✓ تم التطبيق',saved:'✓ تم حفظ الكود',ineligible:'إعادة المحاولة',error:'إعادة المحاولة'} :
        {idle:'Apply coupon',busy:'Applying…',applied:'✓ Applied',saved:'✓ Code saved',ineligible:'Try again',error:'Try again'};
      button.textContent = labels[state];
      card.classList.toggle('helix-coupon--success', state === 'applied' || state === 'saved');
      button.setAttribute('aria-busy', String(busy));
      button.setAttribute('aria-disabled', String(busy || state === 'applied'));
      if (status) status.textContent = state === 'saved' ? (ar ? 'أضف منتجًا مؤهلًا لتطبيق الخصم.' : 'Add an eligible item to apply the discount.') :
        state === 'ineligible' ? (ar ? 'لم يتطبق الخصم على السلة الحالية. راجع شروط الكوبون.' : 'Discount not applied to this cart. Check coupon terms.') :
        state === 'error' ? (ar ? 'تعذر التأكد من التطبيق. حاول تاني.' : 'Could not confirm the discount. Please retry.') :
        state === 'applied' ? (ar ? 'تم تطبيق الكوبون على السلة.' : 'Coupon applied to your cart.') : '';
    });
  }
  async function cartState() {
    var r = await fetch(root + 'cart.js', {credentials:'same-origin',cache:'no-store'});
    if (!r.ok) throw new Error('Cart unavailable');
    return r.json();
  }
  function fromCart(cart) { return applied(cart) ? 'applied' : saved ? (cart.item_count === 0 ? 'saved' : 'ineligible') : 'idle'; }
  async function sync() {
    if (busy) return;
    try { state = fromCart(await cartState()); paint(); } catch (_) {}
  }
  document.addEventListener('click', async function (event) {
    var button = event.target.closest('[data-helix-coupon]');
    if (!button || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    if (busy || state === 'applied') return;
    busy = true; state = 'busy'; paint();
    try {
      // Shopify's shareable link preserves compatible existing discounts.
      var response = await fetch('/discount/extra10?redirect=' + encodeURIComponent(root + 'cart'), {credentials:'same-origin',cache:'no-store'});
      if (!response.ok) throw new Error('Discount request failed');
      saved = true;
      try { sessionStorage.setItem('helix-extra10-saved','1'); } catch (_) {}
      state = fromCart(await cartState());
      if (state === 'applied') {
        document.dispatchEvent(new CustomEvent('cart:reload'));
        // Main cart totals are rendered server-side; reload only this page.
        if (location.pathname.replace(/\/$/,'').endsWith('/cart')) location.reload();
      }
    } catch (_) { state = 'error'; }
    finally { busy = false; paint(); }
  });
  ['cart:update','cart:drawer:render','cart:main:render','discount:update'].forEach(function (name) {
    document.addEventListener(name,function () { clearTimeout(timer); timer = setTimeout(sync,150); });
  });
  new MutationObserver(function (records) {
    if (records.some(function (r) { return Array.from(r.addedNodes).some(function (n) { return n.nodeType === 1 && (n.matches('.helix-coupon') || n.querySelector('.helix-coupon')); }); })) {
      paint(); clearTimeout(timer); timer = setTimeout(sync,150);
    }
  }).observe(document.body,{childList:true,subtree:true});
  window.addEventListener('pageshow',sync);
  sync();
})();
